import {
  produce
} from 'immer';

import {
  IModelState
} from '../types';

export default function reduceToggleAsideCollapsed(state: IModelState): IModelState {
  return produce(state, draft => {
    draft.asideCollapsed = !draft.asideCollapsed;
  });
}
